import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchRetailItems(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('products/retail-items', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteRetailItem(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`products/retail-items/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
